import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getSuggestContentDataTable: ApiMethod<
  Server.SuggestContentDatatable,
  Server.FilterableAppRequestOfSuggestContentColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_SuggestContent_Client(
      undefined,
      identityClient
    );
    const response = await client.suggestContent_datatable_post_V1(data);
    if (response) {
      return response;
    }
    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createSuggestContent: ApiMethod<string, void, any> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_SuggestContent_Client(
      undefined,
      identityClient
    );
    const response = await client.suggestContent_post_V1({ title: data });

    if (response.success) {
      dispatch(
        CommonActions.setAlert({
          show: true,
          type: AlertType.SUCCESS,
          messages: [
            {
              code: 200,
              field: null,
              message: 'تم إرسال اقتراحك',
            },
          ],
        })
      );
    }

    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
  }
};
